<template>
  <div class="examarrangement">
     <el-header>
      <el-page-header @back="goBack" content="成绩详情">
      </el-page-header>
    </el-header>
    <el-table ref="filterTable" :data="tableData" style="width: 100%">
      <el-table-column prop="date" label="考试时间" sortable >
      </el-table-column>
      <el-table-column prop="name" label="考试时长" >
      </el-table-column>
      <el-table-column prop="name" label="考试总分" >
      </el-table-column>
      <el-table-column prop="tag" label="类型" >
        <template slot-scope="scope">
          <el-tag :type="scope.row.tag === '家' ? 'primary' : 'success'" disable-transitions>{{scope.row.tag}}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right">
      <el-pagination background @current-change="pageCurrentChange" :page-count="pageform.pages" :current-page="pageform.pageNum" layout="prev, pager, next" :total="pageform.total" :page-size='9'>
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄',
        tag: '家'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄',
        tag: '公司'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄',
        tag: '家'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄',
        tag: '公司'
      }],
       // 分页插件
      pageform: {
        total: 0,
        pages: 5,  // 总页数
        pageNum: 1, // 当前的页码
        pageSize: 9, // 每页显示条目个数
      },
        params: {
        class_id: this.$store.getters.getUserInfo.class_id,
        page_size: 9,
        page: 1
      },
    };
  },
  computed: {

  },
  created() {

  },
  methods: {
    goBack() {
                this.$router.back()
            },
    formatter(row, column) {
      return row.address;
    },
    filterTag(value, row) {
      return row.tag === value;
    },
    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },
    pageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
      // console.log('当前页:'+ val);
      this.pageform.pageNum = val;
      this.params.page = val;
      //  this.getCourseList();
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  },
};
</script>

<style  lang="less">
</style>



// WEBPACK FOOTER //
// src/components/assessment/examarrangement.vue